import React from 'react';

export interface Props {
  socialProvider: 'facebook' | 'google' | 'apple';
  color?: string; // SVG fill color. Can also be set via CSS (fill) using the className prop
  className?: string;
}

const SocialIcon: React.FC<Props> = ({ socialProvider, color, className }: Props) => {
  const getSocialSvg = () => {
    switch (socialProvider) {
      case 'facebook':
        return (
          <svg
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <path
              d="M13.6895 11.1068L14.2078 7.69417H11.242V5.48058C11.242 4.54672 11.6941 3.63592 13.0502 3.63592H14.5V0.730583C14.5 0.730583 13.2621 0.5 12.0836 0.5C9.42466 0.5 7.73608 2.13483 7.73608 5.0932V7.69417H5V11.1068H7.73608V19.357C8.31279 19.4516 8.91204 19.5 9.52354 19.5C10.135 19.5 10.7343 19.4516 11.311 19.357V11.1068H13.6895Z"
              fill={color}
            />
          </svg>
        );

      case 'google':
        return (
          <svg
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.6 10.229C19.6 9.51996 19.5364 8.83814 19.4182 8.18359H10V12.0518H15.3818C15.15 13.3018 14.4455 14.3609 13.3864 15.07V17.579H16.6182C18.5091 15.8381 19.6 13.2745 19.6 10.229Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.99984 19.9984C12.6998 19.9984 14.9635 19.103 16.618 17.5757L13.3862 15.0666C12.4907 15.6666 11.3453 16.0212 9.99984 16.0212C7.39529 16.0212 5.19075 14.2621 4.40439 11.8984H1.06348V14.4893C2.70893 17.7575 6.09075 19.9984 9.99984 19.9984Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.40455 11.8987C4.20455 11.2987 4.09091 10.6578 4.09091 9.99872C4.09091 9.33963 4.20455 8.69872 4.40455 8.09872V5.50781H1.06364C0.386364 6.85781 0 8.38509 0 9.99872C0 11.6124 0.386364 13.1396 1.06364 14.4896L4.40455 11.8987Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.99984 3.97727C11.468 3.97727 12.7862 4.48182 13.8226 5.47273L16.6907 2.60455C14.9589 0.990909 12.6953 0 9.99984 0C6.09075 0 2.70893 2.24091 1.06348 5.50909L4.40439 8.1C5.19075 5.73636 7.39529 3.97727 9.99984 3.97727Z"
              fill={color}
            />
          </svg>
        );

      case 'apple':
        return (
          <svg
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
          >
            <path
              d="M18.1437 15.5861C17.8385 16.2848 17.4772 16.928 17.0586 17.5193C16.4881 18.3255 16.0209 18.8835 15.6609 19.1934C15.1027 19.702 14.5048 19.9625 13.8644 19.9773C13.4047 19.9773 12.8504 19.8477 12.205 19.5847C11.5576 19.323 10.9626 19.1934 10.4186 19.1934C9.84801 19.1934 9.23608 19.323 8.58155 19.5847C7.92602 19.8477 7.39793 19.9847 6.99417 19.9983C6.38012 20.0242 5.76806 19.7563 5.15713 19.1934C4.7672 18.8563 4.27947 18.2786 3.6952 17.4601C3.06832 16.586 2.55294 15.5725 2.14918 14.417C1.71677 13.1689 1.5 11.9603 1.5 10.7902C1.5 9.44984 1.79226 8.29383 2.37766 7.32509C2.83773 6.54696 3.44978 5.93316 4.21581 5.48255C4.98185 5.03195 5.80955 4.80233 6.70091 4.78763C7.18863 4.78763 7.82822 4.93714 8.62303 5.23096C9.4156 5.52576 9.92451 5.67526 10.1476 5.67526C10.3144 5.67526 10.8798 5.50045 11.8382 5.15195C12.7445 4.82874 13.5094 4.69492 14.136 4.74764C15.834 4.88343 17.1097 5.54675 17.9581 6.74177C16.4395 7.6536 15.6883 8.93072 15.7032 10.5691C15.7169 11.8452 16.1841 12.9071 17.1022 13.7503C17.5183 14.1417 17.983 14.4441 18.5 14.6589C18.3879 14.9812 18.2695 15.2898 18.1437 15.5861ZM14.2494 0.400114C14.2494 1.40034 13.8806 2.33425 13.1456 3.19867C12.2586 4.22629 11.1857 4.8201 10.0223 4.7264C10.0075 4.60641 9.99888 4.48011 9.99888 4.3474C9.99888 3.38718 10.4207 2.35956 11.1698 1.51934C11.5438 1.09392 12.0194 0.74019 12.5962 0.458013C13.1718 0.180046 13.7162 0.0263242 14.2282 0C14.2431 0.133715 14.2494 0.267438 14.2494 0.400101V0.400114Z"
              fill={color}
            />
          </svg>
        );

      default:
        return null;
    }
  };

  return getSocialSvg();
};

export default SocialIcon;
